import Modal from "react-bootstrap/Modal";
import { formatCurrency } from "../../../Utils/helpers";
import moment from "moment";

export default function PayoutResultModal({
  show,
  onHide,
  type,
  result,
  onRetry,
}) {
  const isSuccess = type === "success";
  const isFailed = type === "failed";

  if (!result) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="premium-cms-modal dp-result-modal"
    >
      <Modal.Body className="dp-result-modal__body">
        <div className={`dp-result-icon dp-result-icon--${type}`}>
          <i className={`fas ${isSuccess ? "fa-check" : "fa-times"}`} />
        </div>

        <h4 className="dp-result-modal__title">
          {isSuccess ? "Payout Successful" : "Payout Failed"}
        </h4>

        <p className="dp-result-modal__message">
          {isSuccess
            ? result.driverName
              ? `${result.driverName}'s payout has been processed successfully.`
              : "Wallet balances have been transferred to the selected drivers' bank accounts."
            : result.failureReason ||
              "The payout could not be completed. Please review the details below."}
        </p>

        <div className="dp-result-details">
          {isSuccess && (
            <>
              <div className="dp-result-details__row">
                <span>Reference ID</span>
                <strong>{result.referenceId}</strong>
              </div>
              <div className="dp-result-details__row">
                <span>Drivers Paid</span>
                <strong>{result.driverCount}</strong>
              </div>
              <div className="dp-result-details__row">
                <span>Total Amount</span>
                <strong className="dp-result-details__amount">
                  {formatCurrency(result.totalAmount)}
                </strong>
              </div>
              <div className="dp-result-details__row">
                <span>Processed At</span>
                <strong>{moment(result.processedAt).format("MMM D, YYYY • h:mm A")}</strong>
              </div>
            </>
          )}

          {isFailed && (
            <>
              <div className="dp-result-details__row">
                <span>Failed Drivers</span>
                <strong>{result.failedDrivers?.length || 0}</strong>
              </div>
              {result.failedDrivers?.length > 0 && (
                <ul className="dp-result-failed-list">
                  {result.failedDrivers.map((driver) => (
                    <li key={driver.id}>
                      <span>{driver.name}</span>
                      {driver.blockReason !== result.failureReason && (
                        <span>{driver.blockReason || "Transfer failed"}</span>
                      )}
                    </li>
                  ))}
                </ul>
              )}
              {result.partialSuccess && (
                <div className="dp-result-partial">
                  <i className="fas fa-info-circle" />
                  {result.successCount} driver(s) were paid successfully before the failure.
                </div>
              )}
            </>
          )}
        </div>

        <div className="dp-result-modal__actions">
          {isFailed && onRetry && (
            <button
              type="button"
              className="cms-btn-cancel"
              onClick={onRetry}
            >
              <i className="fas fa-redo me-2" />
              Try Again
            </button>
          )}
          <button
            type="button"
            className={isSuccess ? "cms-btn-save" : "dp-btn-danger"}
            onClick={onHide}
          >
            {isSuccess ? "Done" : "Close"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
